// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"dcc73212","787":"045ebebf"}[chunkId] + ".chunk.js";
};